import { useApolloClient } from '@apollo/client';
import removeAuthCredentials from '../removeAuthCredentials';

export const AuthLogoutPage = () => {
  const client = useApolloClient();

  client.clearStore().then(() => {
    removeAuthCredentials();
    window.location.reload();
  });

  return null;
};

export default AuthLogoutPage;
